export const CHARACTER_LOADED = 'character.LOADED';
export const CHARACTER_SELECTED = 'character.SELECTED';
